<small class="debug">{{me}}</small>
<div style="position: relative;">
  <form class="layout-wrapper">
    @if (sceneSpecificProps && experienceLevel > experienceLevelType.BEGINNER) {
      <mat-form-field style="width: 180px;">
        <mat-label>{{'placeholder.name' | transloco}}</mat-label>
        <input inputrestriction="basic1" autocomplete="off" (change)="onChange('label')" type="text" name="label" [(ngModel)]="model.label" matInput
          placeholder=""/>
        </mat-form-field>
      }
      <br/>
      <br/>
      <div class="cardInner">
        @if (experienceLevel > experienceLevelType.BEGINNER) {
            <div [style.grid-area]="'header'" [ngClass]="{'disable-knob': model.locked == 'true'}">
              <!-- <app-knob *ngIf="sceneSpecificProps" class="center-block" (changed)="onChange('rotation', null, $event)" [min]="0" [max]="360" [value]="model.rotation"></app-knob> -->
              @if (sceneSpecificProps) {
                <app-rotator class="center-block" id="rotator" [value]="model.rotation" (changed)="onChange('rotation', null, $event)"></app-rotator>
              }
            </div>
        }
        <div class="justifyToEnd" [style.grid-area]="'sideA'">
          <mat-form-field>
            <mat-label>{{'placeholder.width' | transloco}}</mat-label>
            <input inputrestriction="numbers" style="width: 50px" max="8192" min="0" type="number" name="width" (change)="onChange('width')" [(ngModel)]="model.width" matInput
              placeholder="" [disabled]="model.locked == 'true'">
            </mat-form-field>
          </div>
          <div class="justifyToStart" [style.grid-area]="'sideB'">
            <mat-form-field>
              <mat-label>{{'placeholder.height' | transloco}}</mat-label>
              <input inputrestriction="numbers" style="width: 50px" max="8192" min="0" type="number" name="height" (change)="onChange('height')" [(ngModel)]="model.height" matInput
                placeholder="" [disabled]="model.locked == 'true'">
              </mat-form-field>
            </div>
            @if (sceneSpecificProps) {
              <div class="justifyToEnd" [style.grid-area]="'sideC'">
                <mat-form-field>
                  <mat-label>X</mat-label>
                  <input style="width: 50px" inputrestriction="numbers" type="number" name="x" (change)="onChange('x')" [(ngModel)]="model.x" matInput placeholder=""
                    [disabled]="model.locked == 'true'">
                  </mat-form-field>
                </div>
              }
              @if (sceneSpecificProps) {
                <div class="justifyToStart" [style.grid-area]="'sideD'">
                  <mat-form-field>
                    <mat-label>Y</mat-label>
                    <input style="width: 50px" inputrestriction="numbers" type="number" name="y" (change)="onChange('y')" [(ngModel)]="model.y" matInput placeholder=""
                      [disabled]="model.locked == 'true'">
                    </mat-form-field>
                  </div>
                }
              </div>
              <div>
                <br/>
                @if (sceneSpecificProps && experienceLevel > experienceLevelType.BEGINNER) {
                  <mat-checkbox (change)="onChange('lock', $event.checked)" [checked]="model.locked === 'true'">
                    {{'general.lockInPlace' | transloco}}
                  </mat-checkbox>
                  <br/>
                }

                @if (experienceLevel > experienceLevelType.BEGINNER) {
                    <mat-checkbox (change)="onChangeScaling($event.checked)" [checked]="model.autoScaling === '1'">
                      {{'general.autoScaling' | transloco}}
                    </mat-checkbox>
                }
              </div>
            </form>
            <div class="constraintWrap">
              @if (sceneSpecificProps && experienceLevel > experienceLevelType.BEGINNER) {
                <app-constraint-checker [setModel]="model" (changed)="onChange($event)"></app-constraint-checker>
              }
            </div>
            <br/>
            <br/>
          </div>
